// extracted by mini-css-extract-plugin
export default {"wrapper":"Section_wrapper__Vy2C8"};